const ReactSelectIndicatorSeparator = () => {
  return null
}

export { ReactSelectIndicatorSeparator }
